import { defineComponent as _defineComponent } from 'vue'
import AuthentcateForm from "@/components/login/AuthentcateForm.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();


const __returned__ = { AuthentcateForm }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})